const techItems = [
  { label: "React", x: "10%", y: "20%", delay: "0s" },
  { label: "Python", x: "80%", y: "15%", delay: "0.5s" },
  { label: "AI/ML", x: "70%", y: "70%", delay: "1s" },
  { label: "TypeScript", x: "15%", y: "75%", delay: "1.5s" },
  { label: "LLMs", x: "85%", y: "45%", delay: "0.8s" },
  { label: "Node.js", x: "25%", y: "45%", delay: "1.2s" },
  { label: "PostgreSQL", x: "55%", y: "85%", delay: "0.3s" },
  { label: "RAG", x: "45%", y: "10%", delay: "1.8s" },
];

export default function FloatingIcons() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {techItems.map((item) => (
        <div
          key={item.label}
          className="absolute animate-fade-in"
          style={{
            left: item.x,
            top: item.y,
            animationDelay: `calc(1s + ${item.delay})`,
            animationFillMode: "both",
          }}
        >
          <div
            className="px-3 py-1.5 rounded-full bg-card/80 backdrop-blur-sm border border-border/50 text-xs font-mono text-muted-foreground animate-float"
            style={{ animationDelay: item.delay }}
          >
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
}
